<template>
  <el-dialog
    class="store-dialog"
    title="变更群组"
    :visible.sync="showDialog"
    :close-on-click-modal="false"
    :before-close="cancelAction"
    append-to-body
    width="1100px"
  >
    <!-- 查询区 -->
    <ul class="search-btn">
      <li>
        <span class="m-r-6">群组名称</span>
        <el-input
          v-model="params.group_name"
          placeholder="请输入内容"
          class="input-m m-r-6"
          clearable
        />
      </li>
      <li>
        <span class="m-r-6">群组编号</span>
        <el-input
          v-model="params.group_code"
          placeholder="请输入内容"
          class="input-m m-r-6"
          clearable
        />
      </li>
      <li>
        <el-button
          type="primary"
          @click="searchList"
        >
          查询
        </el-button>
      </li>
    </ul>

    <div style="margin-bottom: 15px" />
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableList"
      tooltip-effect="dark"
      :row-key="getRowKeys"
      :cell-class-name="getCellClassName"
      default-expand-all
      @select="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="50"
      />
      <el-table-column
        prop="group_name"
        label="群组名称"
      >
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.group_name"
            placement="top"
          >
            <div class="title">
              {{ scope.row.group_name }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="group_code"
        width="200px"
        label="群组编码"
      />
      <el-table-column
        prop="desc"
        label="描述"
      />
    </el-table>
    <div class="tr" />
    <div
      slot="footer"
      class="dialog-footer select-footer"
    >
      <div>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="saveStoreAction"
        >
          确定
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SpGroupsSelect',
  model: {
    prop: 'showDialog',
    event: 'showDialogChange'
  },
  props: {
    showDialog: {
      // 展示选择门店的模态框
      type: Boolean,
      default: false
    },
    submitLoading: {
      //提交的加载
      type: Boolean,
      default: false
    },
    selectedId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      tableList: [],
      total_count: 0,
      params: {
        group_code: '',
        group_name: ''
      }
    }
  },
  watch: {
    showDialog (newVal, oldVal) {
      if (newVal) {
        this.getNewsList()
      }
    }
  },
  methods: {
    // 换页可选择
    getRowKeys (row) {
      return row.id
    },

    // 查询门店
    searchList () {
      this.getNewsList()
    },

    // table表格选择
    handleSelectionChange (val, row) {
      this.$refs.multipleTable.clearSelection()
      if (val.length === 0) {
        return
      }
      if (row) {
        this.selected = row
        this.$refs.multipleTable.toggleRowSelection(row, true)
      }
    },
    // 关闭模态框
    cancelAction () {
      this.$emit('showDialogChange', false)
    },
    // 保存绑定
    saveStoreAction () {
      this.$emit('chooseStore', this.selected)
    },
    // 获取门店列表
    async getNewsList () {
      this.loading = true
      const data = await this.$api.organization.getGroupsList(this.params)
      if (data) {
        this.loading = false
        this.tableList = data.list
        this.total_count = data.total_count

        // this.selectedId.split(',').forEach((id) => {
        //   console.log(id,'000');
        //   this.selectItemOnGetList(id)
        // })
        if (this.selectedId) {
          this.selectItemOnGetList(this.selectedId)
        }
      }
    },
    // 设置row的类名用于获取真实dom
    getCellClassName ({ row }) {
      return `row-${row.id}`
    },
    selectItemOnGetList (id) {
      this.$nextTick(() => {
        try {
          if (!id) {
            return
          }
          const dom = document.querySelector(`.row-${id}`).querySelector('label')
          dom.click()
        } catch (e) {
          console.log(e)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}
.select-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
::v-deep {
  .el-table__header {
    .el-table-column--selection {
      .cell {
        .el-checkbox {
          display: none;
        }
      }
    }
  }
  .el-table__cell {
    .cell {
      display: flex;
      align-items: center;
    }
  }
}
.title {
  display: inline-block;
  min-width: 120px;
  max-width: 220px;
  // line-height: 23px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
